













import Vue, { PropOptions } from 'vue';
import interact from 'interactjs';
import * as models from '@/class/models/views/dashboard';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

const GADGET_HW = 336;
const MARGIN = 10;

interface Methods {
  calcNearestSize: (elem: any) => { w: number, h: number, width: number, height: number };
}
interface Computed {
  W: string;
  H: string;
}
interface Props {
  item: models.IGadgetIndex;
}

export default Vue.extend({
  name: 'DashboardGridItem',
  props: {
    item: Object as PropOptions<models.IGadgetIndex>,
  },
  data() {
    return {
    };
  },
  computed: {
    W() {
      return `${this.item.w * GADGET_HW + MARGIN * (this.item.w - 1) * 2}px`;
      // return `${GADGET_HW * this.item.w}px`;
    },
    H() {
      return `${this.item.h * GADGET_HW + MARGIN * (this.item.h - 1) * 2}px`;
      // return `${GADGET_HW * this.item.h}px`;
    },
  },
  mounted() {
    interact('.item')
      .resizable({
        edges: { top: false, left: false, bottom: '.resize-icon', right: '.resize-icon' },
        onstart: (event) => {
          // console.log('resize start');
          event.target.classList.add('item-resizing');
          this.$emit('resizeStart');
        },
        onend: (event) => {
          // console.log('resize end');
          event.target.classList.remove('item-resizing');
          const { w, h, width, height } = this.calcNearestSize(event.target);
          Object.assign(event.target.style, {
            width: `${width}px`,
            height: `${height}px`,
          });
          if (Number(event.target.id) === Number(this.item.i)) {
            this.item.w = w;
            this.item.h = h;
          }
          // this.item.w = w;
          // this.item.h = h;

          this.$emit('resizeEnd', this.item);
        },
        onmove: (event) => {
          const { width, height } = this.calcNearestSize(event.target);
          Object.assign(event.target.children[1].style, {
            width: `${width}px`,
            height: `${height}px`,
          });

        // },
        // listeners: {
        //   move: function (event) {
        //     // event.stopPropagation();
        //     this.
        //     console.log(event);
        //     // let { x, y } = event.target.dataset
            // let x = event.target.offsetLeft;
            // let y = event.target.pffsetTop;

            // x = (parseFloat(x) || 0) + event.deltaRect.left
            // y = (parseFloat(y) || 0) + event.deltaRect.top
          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            // transform: `translate(${x}px, ${y}px)`
          });

            // Object.assign(event.target.dataset, { x, y })
          // }
        },
      });
  },
  methods: {
    calcNearestSize(elem: any) {
      const myMARGIN = 10; // .itemのmarginの値
      const w = Math.round(elem.clientWidth / GADGET_HW);
      const h = Math.round(elem.clientHeight / GADGET_HW);
      const width = w * GADGET_HW + myMARGIN * (w - 1) * 2;
      const height = h * GADGET_HW + myMARGIN * (h - 1) * 2;
      return { w, h, width, height };
      // const width = w * GADGET_HW;
      // const height = h * GADGET_HW;
      // return { w, h, width, height };
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, {}, Methods, Computed, Props>);

